import * as React from 'react';
import {
    List,
    EditButton,
    Datagrid,
    TextField,
    useGetIdentity,
    ReferenceField,
    TextInput,
    TopToolbar,
    CreateButton,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import usePermissionMiddleware from '../../common/usePermissionMiddleware';
import { AssignPermissionsSuperAdmin } from './AssignPermissionModalSuperAdmin';
import useIsPermission from '../../hooks/useIsPermission';
import UserField from '../../common/UserField';
import AddIcon from "@mui/icons-material/Add";

const OrganizationList = () => {
    const { hasPermission } = usePermissionMiddleware();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { isUpdatable, isWritable } = useIsPermission('ORGANIZATION');
    const filters = [<TextInput label="Search by Name" source="name" alwaysOn fullWidth />];
    const PermissionBasedActionsAdmin = ({ isWritable }:any) => {
      return (
        <TopToolbar>
          {user?.role === 'ADMIN' || isWritable && <CreateButton label="Create" icon={<AddIcon />} />}
        </TopToolbar>
      );
    };

    return (
        <List
            actions={<PermissionBasedActionsAdmin isWritable={isWritable} />}
            filters={filters}
            hasCreate={hasPermission('insert_organizations_one')}
            queryOptions={{
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            }}
        > 
            <Datagrid>
                <TextField source="name" />
                <TextField source="status" />
                <TextField source="minIosVersion" />
                <TextField source="minAndroidVersion" />
                <UserField source="primaryUser" label="Primary User"/>
                <FormattedDateTimeField source="createdAt" />
                {user?.role === 'ADMIN' && <AssignPermissionsSuperAdmin />}

                {isUpdatable && <EditButton />}
            </Datagrid>
        </List>
    );
};
export default OrganizationList;
